<template>
  <CheckPermission
    :container-class="containerClass"
    :permission="permission"
  >
    <input
      ref="file"
      type="file"
      class="d-none"
      @change="uploadFile($event)"
    />
    <b-button
      v-if="typeButton !== 'small'"
      :variant="color"
      :class="buttonClass"
      @click="$refs.file.click()"
      :disabled="progress.enabled"
    >
      {{ text }}
    </b-button>
    <b-button
      v-if="typeButton === 'small'"
      :variant="color"
      :class="buttonClass"
      @click="$refs.file.click()"
      :disabled="progress.enabled"
      size="sm"
    >
      <feather-icon icon="PaperclipIcon" />
    </b-button>
    <vs-progress
      v-if="progress.enabled"
      :percent="progress.percent"
      :indeterminate="progress.indeterminate"
      :color="color"
    />
  </CheckPermission>
</template>
<script>

import { uuid } from 'vue-uuid';
import { BButton } from 'bootstrap-vue';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import { ioGetPrivateMultipartUploadUrl } from '@/febos/servicios/api/herramientas.api';
import { MultipartUploader } from '@/libs/MultipartUploader';

const paths = {
  default: 'escritorio-digital/temporal/'
};

export default {
  data: () => ({
    progress: {
      enabled: false,
      percent: 0,
      indeterminate: true
    }
  }),
  methods: {
    async uploadFile(event) {
      const file = event.target.files[0];

      if (file.size > this.maxSizeInMb * 1048576) {
        this.$emit('input', {
          failed: true,
          failedMessage: `El archivo ${file.name} supera el máximo de tamaño permitido por archivo (${this.maxSizeInMb} MB)`
        });

        return false;
      }

      const internalFileId = uuid.v1();
      const baseUrl = paths[this.uploadTo] || this.uploadTo;
      const url = `${baseUrl}${internalFileId}`;

      try {
        this.progress.enabled = true;
        this.progress.indeterminate = true;
        this.progress.percent = 0;
        const uploader = new MultipartUploader(
          {
            file,
            fileName: file.name,
            fileKey: url
          }
        );

        const {
          data: {
            urls,
            bucket,
            key,
            uploadId
          }
        } = await ioGetPrivateMultipartUploadUrl({
          file: url,
          headers: {
            'content-type': file.type
          },
          parts: uploader.getNumberOfParts()
        });
        this.progress.percent = 0.5;
        this.progress.indeterminate = false;
        uploader.withParts(urls).withUploadId(uploadId).withKey(key).withBuket(bucket);
        uploader.onProgress(({
          percentage = 0
        }) => {
          console.log('onProggres', percentage);
          if (percentage > 0.5) {
            this.progress.percent = percentage;
          }
        }).onComplete(async ({
          fileId,
          parts
        }) => {
          await ioGetPrivateMultipartUploadUrl({
            uploadId: fileId,
            file: url,
            tags: parts
          });
          this.$emit('input', {
            id: internalFileId,
            name: file.name,
            mime: file.type,
            date: this.$moment().format('YYYY-MM-DD HH:MM:ss'),
            path: url,
            failed: false
          });
          this.progress.percent = 100;
          this.progress.indeterminate = false;
        }).finally(() => {
          this.progress.enabled = false;
          this.progress.percent = 0;
          this.progress.indeterminate = false;
        });
        await uploader.start();
        console.log('post start');
      } catch (e) {
        console.error(e);
        this.$emit('input', {
          failed: true,
          failedMessage: e.message
        });
      }
      return true;
    }
  },
  props: {
    permission: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    uploadTo: {
      type: String,
      required: true
    },
    maxSizeInMb: {
      type: Number
    },
    color: {
      type: String,
      default: 'primary'
    },
    buttonClass: {
      type: [String, Object]
    },
    containerClass: {
      type: [String, Object]
    },
    typeButton: {
      type: String
    }
  },
  components: {
    CheckPermission,
    BButton
  }
};

</script>
